import React from 'react';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { useNewsExclusions } from '../NewsExclusionsContext';
import SidebarCard from './SidebarCard';
import { useMaisLidas } from './useMaisLidas';

interface MaisLidasProps {
  /** Token da unidade de origem da notícia aberta. */
  unidade?: string;
}

/**
 * Card "Mais lidas": lista numerada de 1 a 5.
 *
 * A ordenação por audiência real ainda não existe no backend; até lá a lista
 * são as últimas notícias da mesma unidade, descontado tudo que o leitor já vê
 * na página (a notícia aberta, os destaques ao lado e o "Veja também").
 */
export const MaisLidas: React.FC<MaisLidasProps> = ({ unidade }) => {
  const { excluded } = useNewsExclusions();
  const { items, loaded } = useMaisLidas({ unidade, excluded });

  if (loaded && items.length === 0) {
    return null;
  }

  return (
    <SidebarCard title="Mais lidas">
      <ol className="mpf-news-sidebar__list mpf-news-sidebar__list--ranked">
        {items.map((item, index) => (
          <li key={item['@id']} className="mpf-news-sidebar__item">
            <UniversalLink
              href={flattenToAppURL(item['@id'])}
              className="mpf-news-sidebar__ranked"
            >
              <span className="mpf-news-sidebar__rank" aria-hidden="true">
                {index + 1}
              </span>
              <span className="mpf-news-sidebar__ranked-title">
                {item.title}
              </span>
            </UniversalLink>
          </li>
        ))}
      </ol>
    </SidebarCard>
  );
};

export default MaisLidas;
